<template>
  <div>
    <cui-register class=" mb-3 mt-5 pt-3" />
  </div>
</template>
<script>
import CuiRegister from '@/components/cleanui/system/Auth/Register'
export default {
  components: {
    CuiRegister,
  },
}
</script>
